import { api } from "./api";

type PlayerBrandingResponse = Awaited<ReturnType<typeof api.player.branding>>;

// Una sola lectura de /branding por pantalla (Eduardo 2026-10-05): los
// espacios de patrocinador y la barra de abajo del jugador lo piden en el
// mismo momento; la segunda petición se suma a la que ya va en camino. No es
// caché: en cuanto contesta (o falla) se olvida.
const pendingBranding = new Map<string, Promise<PlayerBrandingResponse>>();

export function resetPlayerBrandingRequestsForTests() {
  pendingBranding.clear();
}

export function fetchPlayerBranding(token: string, tournamentId: number): Promise<PlayerBrandingResponse> {
  const key = `${tournamentId}|${token}`;
  const pending = pendingBranding.get(key);
  if (pending) return pending;
  let request: Promise<PlayerBrandingResponse>;
  try {
    request = Promise.resolve(api.player.branding(token, tournamentId));
  } catch (error) {
    request = Promise.reject(error);
  }
  const shared = request.finally(() => pendingBranding.delete(key));
  pendingBranding.set(key, shared);
  return shared;
}
